import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Button,
  Grid,
  ThemeProvider,
  createTheme,
  Typography,
  List,
  ListItem,
  ListItemText,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  IconButton,
  ListItemIcon,
} from '@mui/material';
import {
  ArrowBack,
  Commute,
  Event,
  History,
  Person,
  Link as LinkIcon,
  LocationOn as LocationIcon,
} from '@mui/icons-material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import MailIcon from '@mui/icons-material/Mail';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { motion } from 'framer-motion';
import Breadcrumb from './Breadcrumbs';
import eventsbg from '../../../assets/deveventsbg.png';
import { useGetAllEventsQuery, usePostEventMutation, useUpdateEventMutation } from '../eventsApiSlice';
import { DateRange, FilterAltOutlined, SearchOutlined, Edit, Delete } from '@mui/icons-material';
import toast from 'react-hot-toast';
import UserAvatar from '../../../common/UserAvatar';
import { variants } from '../../../variants/variants';
import Skype from '../../../assets/Skype';
import AttachAvatar from '../../../common/AttachAvatar';
const theme = createTheme({
  typography: {
    fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    h4: {
      fontSize: '2rem',
      fontWeight: 700,
      color: '#222',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.875rem',
      color: '#555',
    },
  },
  palette: {
    primary: {
      main: '#1976d2',
    },
    text: {
      primary: '#000',
      secondary: '#555',
    },
  },
});

const EventDetail = () => {
  const [checked, setChecked] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const [updateEvent] = useUpdateEventMutation();
  const [postEvent] = usePostEventMutation();
  const { data: events } = useGetAllEventsQuery();
  const [open, setOpen] = useState(false);
  const [editingEventId, setEditingEventId] = useState(null);
  const [activeField, setActiveField] = useState('');

  const [newEvent, setNewEvent] = useState({
    eventName: '',
    subtitle: '',
    description: '',
    contactPerson: {
      name: '',
      email: '',
      skype: '',
    },
    eventDetails: {
      startDate: '',
      endDate: '',
      time: '',
      venue: '',
      lastDateOfRegistration: '',
      registrationLink: '',
    },
  });
  const event = events?.data?.find((e) => e._id === id);


  if (!event) {
    return (
      <Typography variant="h6" style={{ textAlign: 'center', marginTop: '2rem' }}>
        Event not found
      </Typography>
    );
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    try {
      if (editingEventId) {
        await updateEvent({ id: editingEventId, ...newEvent }).unwrap();
        toast.success('Event updated successfully!');
      } else {
        await postEvent(newEvent).unwrap();
        toast.success('Event added successfully!');
      }
      setOpen(false);
      setNewEvent({
        eventName: '',
        subtitle: '',
        description: '',
        poster: null,
        contactPerson: {
          name: '',
          email: '',
          skype: '',
        },
        eventDetails: {
          startDate: '',
          endDate: '',
          time: '',
          venue: '',
          lastDateOfRegistration: '',
          registrationLink: '',
        },
      });
    } catch (err) {
      toast.error('Failed to save the event: ' + err.message);
    }
  };


  const handleTextFieldClick = (fieldName) => {
    setActiveField(fieldName);
  };

  const handleEditClick = (event) => {
    setEditingEventId(event._id);
    setNewEvent(event);
    setOpen(true);
  };

  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <ThemeProvider theme={theme}>
      {/* <Grid container sx={{
        backgroundColor: '#EEF5FF',
        color: 'black',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        height: '90vh',
        width: '78vw',
      }}> */}
      <Grid Item sx={{}}>
        <Button size='small' onClick={handleBackClick} sx={{ color: 'black' }}>
          <ArrowBack sx={{ marginRight: '5px' }} /> <Typography sx={{ textDecoration: 'underline' }}>Back</Typography>
        </Button>
        {/* <Breadcrumb paths={[
            { label: 'Home', link: '/home' },
            { label: 'Events', link: '/home/events' },
            { label: event.eventName, link: `/home/events/${id}` }
          ]} /> */}
      </Grid>
      <Box
        sx={{
          marginTop: '0.5rem',
          color: 'black',
          
          display: 'flex',
          gap: 2,
          height: '82vh',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', height: '100%', flexDirection: 'column', gap: 2,  }}>
          <Grid sx={{ width: '30vw', height: '300px', borderRadius: '8px' }}>
            <AttachAvatar
              src={event.poster[0]}
              sx={{ width: 'auto', height: '100%', borderRadius: '8px', objectFit: 'inherit' }}
            />
          </Grid>
          <Box
            sx={{
              backgroundColor: '#FFFF',
              borderRadius: '10px',
              // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',

              width: '30vw',
              height: '25vh',
              overflow: 'auto',
            }}
          >
            <List sx={{}}>
              <ListItem>
                <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
                  Details
                </Typography>
              </ListItem>

              <ListItem variant='h6' sx={{}}>
                <ListItemIcon sx={{ color: 'grey' }}>
                  <LocationOnIcon />
                </ListItemIcon>
                Location : {event.eventDetails.venue}
              </ListItem>
              <ListItem variant='h6' sx={{}}>
                <ListItemIcon sx={{ color: 'grey' }}>
                  <Event />
                </ListItemIcon>
                Date : {new Date(event.eventDetails.startDate).toLocaleDateString()}
              </ListItem>
              <ListItem variant='h6' sx={{}}>
                <ListItemIcon sx={{ color: 'grey' }}>
                  <AccessTimeFilledIcon />
                </ListItemIcon>
                Time : {event.eventDetails.time}
              </ListItem>
              <ListItem variant='h6' sx={{}}>
                <ListItemIcon sx={{ color: 'grey' }}>
                  <History />
                </ListItemIcon>
                End Date : {new Date(event.eventDetails.endDate).toLocaleDateString()}
              </ListItem>
            </List>
          </Box>
          <Box
            sx={{
              height: '23vh',
              backgroundColor: '#FFFF',
              borderRadius: '10px',
              // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              width: '30vw',
              overflow: 'auto',
            }}
          >
            <List sx={{ width: '100%', maxWidth: 360 }}>
              <ListItem>
                <Typography variant='h6' sx={{ fontWeight: 'bold', mb: 0.5 }}>
                  Contact Person
                </Typography>
              </ListItem>
              <ListItem variant='h6' sx={{}}>
                <ListItemIcon sx={{ color: 'grey' }}>
                  <Person />
                </ListItemIcon>
                Name : {event.contactPerson.name}
              </ListItem>
              <ListItem variant='h6' sx={{}}>
                <ListItemIcon sx={{ color: 'grey' }}>
                  <AlternateEmailIcon />
                </ListItemIcon>
                Skype : {event.contactPerson.skype}
              </ListItem>
              <ListItem variant='h6' sx={{}}>
                <ListItemIcon sx={{ color: 'grey' }}>
                  <MailIcon />
                </ListItemIcon>
                Email : {event.contactPerson.email}
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box
          sx={{
            p: 3,
            borderRadius: '10px',
            // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            width: '45vw',
            height: '100%',
            backgroundImage: `url(${eventsbg})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backdropFilter: 'blur(200px)',
          }}
        >
          <Typography variant='h6' sx={{ fontWeight: 'bold', mb: 2 }}>
            {event.eventName} Details - <span style={{ color: 'grey', fontSize: '16px' }}>{event.subtitle}</span>
          </Typography>

          <List sx={{ width: '100%' }}>
            <ListItem>{event.description}</ListItem>
          </List>

          <Grid sx={{ display: 'flex', width: '100%', alignItems: 'center' }}>
            <ListItem sx={{ gap: 1 }}>
              <Typography fontWeight={'bold'}>
                Register before {new Date(event.eventDetails.lastDateOfRegistration).toLocaleDateString()} :
              </Typography>
              <Link to={event.eventDetails.registrationLink}>{event.eventDetails.registrationLink}</Link>
            </ListItem>
          </Grid>
        </Box>
        {/* </List> */}
      </Box>
      {/* </Grid> */}
    </ThemeProvider>
  );
};

export default EventDetail;
